import {
  CAS_URL,
  WIDGET_ID,
  IFRAME_SRC,
  IFRAME_ID,
  IFRAME_CLOSE_TIMEOUT,
  IFRAME_SOURCE_ID,
  HOST_SOURCE_ID,
} from './constants';
import { publish } from '@wh/message-bus';
import { Integrator, Widget } from './lib';
import { FosWidgetEventsMap, FosWidgetListenersMap } from './types';
import { nativeShare } from './utils';

import './css/main.css';

export const init = (): void => {
  if (document.documentMode) {
    return;
  }

  const initialHash = window.location.hash;

  const widget = new Widget<FosWidgetListenersMap, FosWidgetEventsMap>({
    id: WIDGET_ID,
    iframeId: IFRAME_ID,
    iframeSourceId: IFRAME_SOURCE_ID,
    hostSourceId: HOST_SOURCE_ID,
    baseUrl: IFRAME_SRC,
    timeout: IFRAME_CLOSE_TIMEOUT,
    listeners: {
      'add-selection': ({ payload }) => {
        publish('wh.sports.betslip.adapter.leg.add', {
          id: payload.selectionId.replace('OB_OU', ''),
          analytics: payload.analytics,
        });
      },
      'add-selections': ({ payload }) => {
        publish('wh.sports.betslip.adapter.legs.add', {
          allBetIds: payload.selections.map((s) => ({
            id: s.selectionId.replace('OB_OU', ''),
            analytics: payload.analytics,
          })),
        });
      },
      'remove-selection': ({ payload }) => {
        publish(
          'wh.sports.betslip.adapter.leg.remove',
          payload.selectionId.replace('OB_OU', ''),
        );
      },
      'remove-selections': ({ payload }) => {
        payload.selections.forEach((s) => {
          publish(
            'wh.sports.betslip.adapter.leg.remove',
            s.selectionId.replace('OB_OU', ''),
          );
        });
      },
      'share-league': ({ payload }) => nativeShare(payload),
      close: () => {
        publish('wh.sb.widget.stop', { id: widget.config.id });
      },
    },
  });

  const integrator = new Integrator(widget, {
    auth: {
      casUrl: CAS_URL,
    },
    listeners: {
      'wh.sb.widget.start_success': ({ id }) => {
        if (id !== widget.config.id) {
          return;
        }

        const league = initialHash.split(`${widget.config.iframeSourceId}-`)[1];

        if (league) {
          widget.postMessage('open-league', { code: league });
        }
      },

      'wh.sports.betslip.adapter.list.selections': (selectionIds) => {
        widget.postMessage('update-betslip', {
          selections: selectionIds.map((id) => ({ selectionId: id })),
        });
      },

      onOddsFormatChanged: (format) => {
        widget.postMessage('odds-format', { format });
      },
    },
  });

  integrator.init();
};
